import { injectable } from 'inversify'

export interface IAuth0Config {
  getAuth0Domain (): string
  getAuth0ClientId (): string
  getAuth0RedirectUri (): string
}

@injectable()
export class Auth0Config {
  private auth0Domain: string
  private auth0ClientId: string
  private auth0RedirectUri: string

  constructor() {
    this.auth0Domain = process.env.VUE_APP_AUTH0_DOMAIN ? process.env.VUE_APP_AUTH0_DOMAIN : 'error'
    this.auth0ClientId = process.env.VUE_APP_AUTH0_CLIENTID ? process.env.VUE_APP_AUTH0_CLIENTID : 'error'
    this.auth0RedirectUri = process.env.VUE_APP_AUTH0_REDIRECT ? process.env.VUE_APP_AUTH0_REDIRECT : 'error'
  }
  public getAuth0Domain (): string { return this.auth0Domain }
  public getAuth0ClientId (): string { return this.auth0ClientId }
  public getAuth0RedirectUri (): string { return this.auth0RedirectUri }
}
